export class AelfAbstract {
    constructor() {
        this.getInstance = (chainId, rpcUrl) => {
            if (this.instances[chainId]) {
                return this.instances[chainId];
            }
            else {
                const instance = this.aelfSDK.getAelfInstance(rpcUrl);
                this.instances[chainId] = instance;
                return instance;
            }
        };
        this.instances = {
            AELF: undefined,
            tDVV: undefined,
            tDVW: undefined,
        };
    }
}
